import * as yup from 'yup';

const updateEmailValidationSchema = yup.object().shape({
  userNewEmail: yup
    .string()
    .email("Invalid email address")
    .required("Email is required")
    .test('not-same', 'Email must be different from the previous one.', function(value) {
      const { previousValue } = this.parent; // Get previousValue from the form
      return value !== previousValue; // Check if the new email is different from the previous value
    }),
});

const updatePhoneValidationSchema = yup.object().shape({
  userPhone: yup
    .string()
    .required("Phone number is required")
    .test('not-same', 'Phone number must be different from the previous one.', function(value) {
      const { previousValue } = this.parent; // Get previous value from the form
      // Clean the input value and previous value to make sure they are compared without spaces or special characters
      const cleanedValue = value?.replace(/\D/g, ''); // Remove non-numeric characters
      const cleanedPreviousValue = previousValue?.replace(/\D/g, ''); // Clean the previous number
      
      return cleanedValue !== cleanedPreviousValue; // Ensure the phone numbers are different
    })
});

const otpValidationSchema = yup.object().shape({
  otp: yup.string().required("Otp is required").min(6).max(6),
})

export {updateEmailValidationSchema, updatePhoneValidationSchema, otpValidationSchema}